import { Box } from "@mui/material";
import BigLogo from "@publicPortal/components/bigLogo/BigLogo";
import Board from "@publicPortal/components/board/Board";
import { memo } from "react";
import "./TermsAndConditions.css";
import useSessionStorage from "@mirage/hooks/useSessionStorage";

const TermsAndConditions = memo(() => {
    const [sessionStorage] = useSessionStorage("publicportal");
    const content = sessionStorage?.clientSettings?.TERMS_AND_CONDITIONS || `<h1>NO TERMS PROVIDED</h1>`;

    return (
        <>
            <BigLogo />
            <Board size="big" headerText="Terms & Conditions" className="terms-and-conditions-board">
                <Box dangerouslySetInnerHTML={{ __html: content }} paddingX="1rem" />
            </Board>
        </>
    );
});

export default TermsAndConditions;
